import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ProductRole } from '../../models/admin-models/product-role.model';

@Injectable({
    providedIn: 'root'
})
export class ProductRoleService {

    constructor(private httpClient: HttpClient) { }

    getRoleByProduct(id: number) {
        return this.httpClient.get('api/ProductTypesRoles/getbyproduct/' + id)
    }

    gridView() {
        return this.httpClient.get('api/ProductTypesRoles');
    }

    createProductRole(productRole: ProductRole) {
        return this.httpClient.post('api/ProductTypesRoles/create', productRole.data).toPromise();
    }

    editProductRole(productRole: ProductRole) {
        return this.httpClient.post('api/ProductTypesRoles/edit', productRole.data).toPromise();
    }

    deleteProductRole(productType: Number, roleIDs: Number) {
        let productDelete = { ProductType: productType, RoleIDs: [roleIDs] }
        return this.httpClient.post('api/ProductTypesRoles/deletebyrole', productDelete);
    }

}